import { render } from "./ModalforApp.vue?vue&type=template&id=0775003d&scoped=true"
import script from "./ModalforApp.vue?vue&type=script&lang=js"
export * from "./ModalforApp.vue?vue&type=script&lang=js"

import "./ModalforApp.vue?vue&type=style&index=0&id=0775003d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-iframe-br/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0775003d"]])

export default __exports__